'use client'

import { Link } from 'react-router-dom'
import {
  Leaf,
  Milk,
  Croissant,
  Beef,
  Package,
  Snowflake,
  Coffee,
  Cookie,
  Home,
  Sparkles,
} from 'lucide-react'
import { useCategories } from '@/hooks/useProducts'

const ICON_MAP: Record<string, any> = {
  Leaf,
  Milk,
  Croissant,
  Beef,
  Package,
  Snowflake,
  Coffee,
  Cookie,
  Home,
  Sparkles,
}

export default function CategoriesSection() {
  const { data: categories, isLoading } = useCategories()

  if (isLoading || !categories) {
    return null
  }

  return (
    <section className="py-8">
      <div className="container mx-auto px-4">
        <h2 className="text-2xl font-bold text-foreground mb-6">Shop by Category</h2>

        <div className="grid grid-cols-4 md:grid-cols-5 lg:grid-cols-10 gap-4">
          {categories.map((category) => {
            const IconComponent = ICON_MAP[category.icon] || Package

            return (
              <Link
                key={category.id}
                to={`/products?category=${category.id}`}
                className="flex flex-col items-center gap-2 p-4 rounded-lg hover:bg-muted transition-colors group"
              >
                <div className="w-16 h-16 rounded-full bg-muted flex items-center justify-center group-hover:bg-primary/10 transition-colors">
                  <IconComponent className="h-8 w-8 text-primary" />
                </div>
                <span className="text-xs text-center text-foreground font-medium line-clamp-2">
                  {category.name}
                </span>
              </Link>
            )
          })}
        </div>
      </div>
    </section>
  )
}
